// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_fb-6";
export var emphasizeQuantity = "_fb-3";
export var flatBottomCorners = "_fb-5";
export var productImage = "_fb-0";
export var quantityContainer = "_fb-2";
export var tooltip = "_fb-1";
export var wrapAndEllipsesOverflow = "_fb-4";